import React, { Component, Dispatch } from 'react';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import { IAddActivityFooterProps } from '../../models/components/add-activity-footer-props';
import { ActivityTypeEnums } from '../../models/enums/ActivityType';
import { IAction, IAppState } from '../../models/action/core'
import { connect } from 'react-redux';
import { Label } from 'reactstrap';
import { Button } from '../ui-elements/main';

const T = Translator.create();
const _logger = Log.create('main-tabpanel');

interface AddActivityFooterState {
    activeButton?: string;
}

export class AddActivityFooter extends Component<IAddActivityFooterProps, AddActivityFooterState> {
    constructor(props: any) {
        super(props);
        this.state = { activeButton: undefined };
    }

    onMouseUp = () => {
        this.props.addQuestionButtonClick();
    };

    public componentDidUpdate(prevProps: IAddActivityFooterProps) {
        if (this.props.publishDatas && this.props.publishDatas !== prevProps.publishDatas) {
            if (this.props.publishDatas.isPassive && this.props.currentTab !== '_sessionTab' && this.props.selectedExamSession?.examSessionId) {
                this.props.validateTabAndChange(this.props.formikProps, false, '_sessionTab', false)
            }
        }
    }

    getButtonText = () => {

        const { isLoadingProcess, addQuestion, activityType } = this.props;
        const { activeButton } = this.state;

        if (isLoadingProcess && addQuestion !== undefined && activeButton === 'save') {
            return T.t('r_gen_saving');
        }

        if (isLoadingProcess && addQuestion === undefined) {
            return T.t('r_gen_sharing');
        }

        if (activityType === ActivityTypeEnums.Exam) {
            return <>{T.t('r_exam_save_and_go_session')}</>;
        }

        return T.t('r_gen_save');
    };

    handleButtonClick = (buttonKey: string, callback: () => void) => {
        this.setState({ activeButton: buttonKey }, callback);
    };

    public render() {

        const { isLoadingProcess, isDisabled, spinnerId } = this.props;
        const { activeButton } = this.state;

        return (
            <div className="modal-footer d-block">
                <div className="row">
                    <div className="col-md">

                        <Button button_type='secondary'
                            text={T.t('r_cancel_button')}
                            size='large'
                            onClick={this.props.setCloseModal}
                            iconPosition='left'
                            materialicon='close'
                        />
                    </div>
                    <div className="col-md text-md-right">
                        {this.props.currentTab === '_activitySettingTab' || this.props.isProjectSubActivity ? (
                            <>
                                {this.props.addQuestion ?
                                    <Button
                                        on
                                        button_type={isLoadingProcess ? (activeButton === 'addQuestion' ? 'primary' : 'secondary') : 'primary'}
                                        id={'btn-' + spinnerId}
                                        disabled={isDisabled || (isLoadingProcess && activeButton !== 'addQuestion')}
                                        onMouseUp={this.onMouseUp}
                                        text={(isLoadingProcess && activeButton === 'addQuestion') ? T.t('r_gen_saving') : T.t('r_save_and_create_new')}
                                        size='large'
                                        style={{ margin: '0 8px' }}
                                        onClick={() => this.handleButtonClick('addQuestion', () => this.props.validateTabAndChange(this.props.formikProps, false, undefined, true, true))}
                                    />
                                    : ''
                                }

                                <Button
                                    button_type={isLoadingProcess ? (activeButton === 'save' ? 'primary' : 'secondary') : 'primary'}
                                    id={'btn-' + spinnerId}
                                    disabled={isDisabled || (isLoadingProcess && activeButton !== 'save')}
                                    text={(isLoadingProcess && activeButton === 'save') ? T.t('r_gen_saving') : this.getButtonText()}
                                    size='large'
                                    onClick={() => this.handleButtonClick('save', () => this.props.validateTabAndChange(this.props.formikProps, false, undefined, true))}
                                />
                            </>
                        ) : (
                            this.props.currentTab !== '_questionsTab' && this.props.currentTab !== '_sessionTab' && this.props.spinnerId !== 'addQrPollingLoading' ? (

                                <Button button_type='primary'
                                    text={T.t('r_continue_button')}
                                    size='large'
                                    iconPosition='right'
                                    materialicon='arrow_forward'
                                    onClick={() => this.props.validateTabAndChange(this.props.formikProps, true)}
                                />
                            ) : (
                                this.props.spinnerId === 'addQrPollingLoading' &&

                                <Button button_type='primary'
                                    text={T.t('r_attendance_create_new')}
                                    size='large'
                                    onClick={() => this.props.validateTabAndChange(this.props.formikProps, true)}
                                />
                            )
                        )}

                        {
                            this.props.currentTab === '_questionsTab' ? (

                                <Button button_type='primary'
                                    text={T.t('r_save_questions')}
                                    size='large'
                                    onClick={() => this.props.validateTabAndChange(this.props.formikProps, true, undefined, undefined, true)}
                                    iconPosition='right'
                                    materialicon='arrow_forward'
                                    disabled={this.props.isDisabled}
                                />
                            ) : ''
                        }

                    </div>
                </div>
                <div className="row" style={{ marginInlineStart: document.body.getAttribute('dir') == 'rtl' ? '20px' : '0px' }}>
                    <Label>
                        {this.props.formikProps.values.abbreviation ? this.props.formikProps.values.abbreviation : ''}
                    </Label>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IAddActivityFooterProps): IAddActivityFooterProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IAddActivityFooterProps = Object.assign({}, ownProps, {
        publishDatas: state.examSession.publishDatas,
        selectedExamSession: state.examSession.selectedSession
    });

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.examSession.selectedSession === prev.examSession.selectedSession &&
        next.examSession.publishDatas === prev.examSession.publishDatas;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CAddActivityFooter = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(AddActivityFooter);

export default CAddActivityFooter;
